<div class="dialog dialog--reality-check">
  <h4 class="dialog__title">Reality Check</h4>

  @if (data.note) {
    <p class="dialog__content">{{ data.note }}</p>
  }

  <footer class="dialog__footer">
    <button type="button" matRipple class="btn btn--action" (click)="close()">
      Close
    </button>
    <button type="button" matRipple class="btn btn--action" (click)="goToAccount()">
      My account
    </button>
    <button type="button" matRipple class="btn btn--action" (click)="logout()">
      Logout
    </button>
  </footer>
</div>
